import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { MessageService } from '@progress/kendo-angular-l10n';

import { Constants } from '../../util/constants';
import { enComponentMessages, enCustomMessages } from './messages/en-US';
import { roComponentMessages, roCustomMessages } from './messages/ro';

const componentMsgs: any = {
    [Constants.LOCALE_EN]: enComponentMessages,
    [Constants.LOCALE_RO]: roComponentMessages
};

const customMsgs: any = {
    [Constants.LOCALE_EN]: enCustomMessages,
    [Constants.LOCALE_RO]: roCustomMessages
};

@Injectable({ providedIn: 'root' })
export class CustomMessagesService extends MessageService {
    private localeId = Constants.LOCALE_EN;
    private localeChange = new BehaviorSubject(this.localeId);
    public sharedLanguage = this.localeChange.asObservable();

    public set language(value: string) {
        const locale = componentMsgs[value];
        if (locale) {
            this.localeId = value;
            this.localeChange.next(value);
            this.notify();
        }
    }

    public get language(): string {
        return this.localeId;
    }

    private get messages(): any {
        const messages = componentMsgs[this.localeId];
        if (messages) {
            return messages;
        }
    }

    public override get(key: string): string {
        return this.messages[key];
    }

    // Translate custom messages
    public translate(word: string): string {
        const messages = customMsgs[this.localeId];

        return messages[word];
    }
}
